import React from 'react';
import { ArrowRightIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { LOGO_URL, PHONE_DISPLAY, PHONE_HREF, SALES_EMAIL, headerNavLinks } from '../data/homepage';
export function SiteFooter() {
  return <footer className="on-dark bg-ink text-white" data-id="element-176" data-mp="3mghl8tk78fo6">
      <div className="mx-auto max-w-[1280px] px-5 py-8 md:px-8" data-id="element-177" data-mp="3mf6i8vykvby4">
        <div className="grid items-start gap-7 md:grid-cols-2 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.25fr)_minmax(0,1fr)] lg:gap-12" data-id="element-178" data-mp="3hhwvjo2kpedz">
          <div className="md:col-span-2 lg:col-span-1" data-id="element-179" data-mp="3dei666sqvlnv">
            <a href="#top" className="inline-flex max-w-full" aria-label="WebsiteForge, back to top" data-id="element-180" data-mp="38gyrj5s4x6ve">
              <img src={LOGO_URL} alt="" className="h-14 w-auto max-w-full md:h-16" width={196} height={44} data-id="element-181" data-mp="33j6yg8fr7epm" />
            </a>
            <p className="mt-3 max-w-[270px] text-[15px] font-semibold leading-[1.6] text-white/80" data-id="element-182" data-mp="2ylopwj5nf1i5">
              Websites, marketing, and technology. Handled.
            </p>
          </div>
          <nav aria-label="Footer" data-id="element-183" data-mp="wq4i42mnir4y">
            <h2 className="text-[13px] font-bold uppercase leading-5 text-white/60" data-id="element-184" data-mp="15r5391x8bgrr">Explore</h2>
            <ul className="mt-2 grid grid-cols-2 gap-x-5" data-id="element-185" data-mp="1apopl3fqiukn">
              {headerNavLinks.map(link => <li key={link.href} data-id="element-186" data-mp="vt7bi4g5v1ue">
                  <a href={link.href} className="inline-flex min-h-11 items-center py-2 text-[15px] font-semibold leading-snug text-white/85 hover:text-white hover:underline" data-id="element-187" data-mp="vu8oiegqlyer">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>
          <div data-id="element-188" data-mp="1tfwmv4wr6qsx">
            <h2 className="text-[13px] font-bold uppercase leading-5 text-white/60" data-id="element-189" data-mp="1tiisv03zwy91">Talk to us</h2>
            <ul className="mt-2" data-id="element-190" data-mp="1epgzpkks18s4">
              <li data-id="element-191" data-mp="1jqd37x17usx0">
                <a href={PHONE_HREF} className="inline-flex min-h-11 items-center gap-3 text-[16px] font-bold text-white/90 hover:text-white hover:underline" data-id="element-192" data-mp="1jpuwu7kuaybd">
                  <PhoneIcon className="h-4 w-4 shrink-0 text-brand-orange" aria-hidden data-id="element-193" data-mp="27ee8mx33lt87" />
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li data-id="element-194" data-mp="2m2e6gj810lyb">
                <a href={`mailto:${SALES_EMAIL}`} className="inline-flex min-h-11 items-center gap-3 text-[15px] font-semibold text-white/85 hover:text-white hover:underline" data-id="element-195" data-mp="2m0tnlqv2qrga">
                  <MailIcon className="h-4 w-4 shrink-0 text-brand-orange" aria-hidden data-id="element-196" data-mp="2d0wwzjp4jiil" />
                  {SALES_EMAIL}
                </a>
              </li>
              <li data-id="element-197" data-mp="233s7pazzf6xk">
                <a href="#contact" className="inline-flex min-h-11 items-center gap-2 text-[15px] font-bold text-brand-orange hover:underline" data-id="element-198" data-mp="234br6w5a63dp">
                  Discuss Your Project
                  <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden data-id="element-199" data-mp="1tdqtrc1cf4wd" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <p className="mt-6 border-t border-ink-line pt-4 text-[13px] text-white/60" data-id="element-200" data-mp="1pakdrcofhzcp">&copy; 2026 WebsiteForge</p>
      </div>
    </footer>;
}